import update from 'immutability-helper';
import {
  AddOperationItemAction, SetOperationItemAction,
  SetOperationItemsAction, SetSelectedClientTransactionIdAction
} from './actions';
import { createCase, createSwitch } from 'helpers/action-helpers';
import { Guid } from 'types/guid';
import { initialState } from './state';
import { OperationItem } from 'types/operation-item';

export const operationGridReducer = createSwitch(initialState, [
  createCase(new SetSelectedClientTransactionIdAction(''), (state, action) => {
    return update(state, {
      selectedClientTransactionId: { $set: action.clientTransactionId }
    });
  }),
  createCase(new AddOperationItemAction({} as OperationItem), (state, action) => {
    const rows = [action.operationItem, ...state.items];
    return update(state, {
      items: { $set: rows }
    });
  }),
  createCase(new SetOperationItemsAction([], []), (state, action) => {
    const allRows: OperationItem[] = [...action.pendingRows, ...action.completedRows];

    return update(state, {
      items: { $set: allRows }
    });
  }),
  createCase(new SetOperationItemAction('', {} as OperationItem), (state, action) => {
    let itemIndex = getIndex(state.items, action.clientTransactionId);

    const updatedItems = state.items.map((item, index) => {
      if (itemIndex !== index) {
        return item;
      }
      return action.operationItem;
    });

    return update(state, {
      items: {
        $set: updatedItems
      }
    });
  })
]);

function getIndex(rows: OperationItem[], clientTransactionId: Guid): number {
  let clientTransactionIds = rows.map(r => r.clientTransactionId);
  let index = clientTransactionIds.indexOf(clientTransactionId.toString());
  return index;
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/reducer.ts